import api from "./api";
import apiFunctions from "./functions";

/**
 * Trae la cotizacion del dolar oficial y mep (bolsa) segun la fecha indicada.
 * (Nota)   en la api viene el parametro "fecha_actualizacion" con formato DateTime si es la fecha actual
 *          y viene el parametro "fecha" con formato Date si es un valor historico (anterior al actual)
 *          solo viene uno de los dos.
 *
 * @param {string} fecha - En formato DateTime
 * @returns {Promise<Object>} Un promise que resuelve en los datos de la cotizacion del dolar o success en "false" con los errores para mostar.
 */
export const getCotizacionDolar = (fecha) => {
    const formattedFecha = fecha.format('DD/MM/YYYY');

    return new Promise((resolve) => {
        apiFunctions.get(
            api.imputaciones.imputaciones.cotizacionDolar + "/" + formattedFecha,
            null,
            null,
            null,
            (response) => {
                resolve(response);
            },
            (error) => {
                resolve(error)
            }
        );
    });
}

/**
 * Trae la tabla Facturacion entera sin paginado filtrada por un rango de fechas.
 *
 * @param {string} fechaFilter - Objeto que tiene el filtro de un rango de fechas.
 * @returns {Promise<Object>} Un promise que resuelve en los datos de la tabla Facturacion filtrada por un rango de fechas.
 */
export const getTablaFacturacionPorFiltro = (fechaFilter) => {
    const data = {
        "columns": [
            "numero_presupuesto",
            "fechaDeFacturacion",
            "fechaDeCobro",
            "monto",
            "cotizacion_dolar_oficial",
            "cotizacion_dolar_mep",
            "monto_dolar_oficial",
            "monto_dolar_mep",
        ],
        "table": {
            "pageSize": 9999999999, // Para poder filtrar sin paginacion
            "page": 0,
            "sorted": [], // No hace falta aplicar el mismo sort que en la tabla de Facturacion
            "filtered": fechaFilter,
        }
    }

    const dataString = JSON.stringify(data);

    const parameters = {
        filters: [`data=${dataString}`]
    };

    return new Promise((resolve) => {
        apiFunctions.get(
            api.imputaciones.imputaciones.facturas.list,
            null,
            null,
            parameters,
            (response) => {
                resolve(response);
            },
            (error) => {
                reject(error)
            }
        );
    });
}



// WEBPACK FOOTER //
// ./src/api/calls.js